<template>
  <div
    :class="{isPc:isPc, dark: $vuetify.theme.dark}"
    class="HljFarawayTextRoot"
  >
    <h4 class="py-2">
      海運偏遠地區預估費用參考
    </h4>
    <table class="table-comment mt-1">
      <tr>
        <th width="100">
          偏遠派件區域
        </th>
        <th>區域明細</th>
      </tr>
      <tr>
        <td>基隆、台北、新北偏遠區域</td>
        <td>
          萬里、九份、金山、石碇、平溪、石門、雙溪、貢寮、坪林、烏來、三芝、暖暖、瑞芳
        </td>
      </tr>
      <tr>
        <td>桃園偏遠區域</td>
        <td>
          復興、新屋、觀音、大溪
        </td>
      </tr>
      <tr>
        <td>新竹偏遠區域</td>
        <td>
          橫山、五峰、尖石、新埔、峨眉、北埔、新豐
        </td>
      </tr>
      <tr>
        <td>苗栗偏遠區域</td>
        <td>
          三灣、獅潭、卓蘭、大湖、泰安、苑裡、南庄、後龍、通霄、三義、西湖
        </td>
      </tr>
      <tr>
        <td>台中偏遠區域</td>
        <td>
          新社、和平、石岡、東勢、大安、外埔、后里
        </td>
      </tr>
      <tr>
        <td>南投偏遠區域</td>
        <td>
          信義、鹿谷、仁愛、魚池、竹山、中寮、國姓、埔里、名間、水里、集集
        </td>
      </tr>
      <tr>
        <td>彰化偏遠區域</td>
        <td>
          芬園、埔鹽、竹塘、二林、大城、芳苑、二水、溪州、永靖、埔心、溪湖、大村、田中、北斗、田尾、埤頭
        </td>
      </tr>
      <tr>
        <td>雲林偏遠區域</td>
        <td>
          東勢、麥寮、水林、口湖、四湖、元長、臺西、崙背、二崙
        </td>
      </tr>
      <tr>
        <td>嘉義偏遠區域</td>
        <td>
          番路、梅山、阿里山、鹿草、六腳、大林、義竹、布袋、大埔、太保、朴子、東石、新港、民雄、溪口
        </td>
      </tr>
      <tr>
        <td>台南偏遠區域</td>
        <td>
          楠西、南化、左鎮、玉井、山上、大內、官田、後壁、西港、白河、七股、將軍、東山、北門、龍崎、柳營、六甲、學甲、下營、新化、新市
        </td>
      </tr>
      <tr>
        <td>高雄偏遠區域</td>
        <td>
          寶來、田寮、旗山、阿蓮、湖內、茄萣、六龜、甲仙、旗津、茂林、桃源、永安、內門、杉林、大樹、美濃、那瑪夏
        </td>
      </tr>
      <tr>
        <td />
        <td>
          屏東、宜蘭、花蓮、台東
        </td>
      </tr>
    </table>
    <div class="mt-2">
      * 以上偏遠地區每票基本費用為新台幣700元(每材加收新台幣15元或每公斤新台幣5元)，離島區域需另外報價<br>
      * 超長及超重之貨物可能需要自取，若需安排派送則另外報價
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isPc: window.isPc
    }
  },
}
</script>

<style lang="postcss" scoped>
.HljFarawayTextRoot {
  font-size: 14px;
  h4 {
    font-size: 16px;
  }
}
.cityTr {
 text-align: center;
 background: #a4e1ff;
 color: #000;
 font-weight: bold;
 font-size: 1.1em;
}
.price-td {
  font-weight: bold;
  text-align: right;
}
.dark {
  .cityTr {
    background: #eaeaea;
  }
}
</style>
